module.exports = __webpack_public_path__ + "img/nine-thirty.f80ada5e.png";